module.exports = __webpack_public_path__ + "static/media/work-bag.d0647700.svg";